import React, { useState, useRef, useEffect } from "react";


import { Link } from "react-router-dom";
const Footer =() => {
      const activateTab = (tabId) => {
      // Remove active/show from all tabs
      const allTabs = document.querySelectorAll(".tab-pane");
      allTabs.forEach(tab => {
        tab.classList.remove("active", "show");
      });
    
      // Remove active class from all nav links
      const allNavLinks = document.querySelectorAll(".nav-link");
      allNavLinks.forEach(link => link.classList.remove("active", "show"));
    
      // Add active/show to clicked tab
      const targetTab = document.getElementById(tabId);
      if (targetTab) targetTab.classList.add("active", "show");
    
      // Add active class to corresponding nav link
      const navLink = document.querySelector(`a[data-bs-target="#${tabId}"]`);
      if (navLink) navLink.classList.add("active", "show");
    
      // Scroll to services section smoothly
      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
       };
    
    return (
        <div>
             {/* Footer */}
<footer id="footer" className="footer">
  <div className="container footer-top">
    <div className="row gy-4">

      <div className="col-lg-4 col-md-6 footer-about">
        <Link to="/" className=" d-flex align-items-center">
          {/* <span className="sitename">Bojo Technologies</span> */}
     <img 
  src="assets/footer_logo1.svg" 
  alt="BojoTech Logo" 
  className="footer-logo-img" 
/>


        </Link>
        <div className="footer-contact pt-3 ">
          <p>We build innovative digital solutions that help businesses grow, scale, and transform in the modern world.</p>
          <p>From custom software and cloud platforms to AI-driven solutions, BojoTech empowers organizations with reliable technology and expert development.</p>
         
        </div>
        <div className="social-links d-flex mt-4">
          <Link to="https://www.instagram.com/bojotech?igsh=cjBvZDkyMjEyZDBs&utm_source=ig_contact_invite "><i className="bi bi-instagram" /></Link>
          <Link to="https://www.linkedin.com/in/bojo-tech-11a1253a0"><i className="bi bi-linkedin" /></Link>
        </div>
      </div>
       <div className="col-lg-4 col-md-3 footer-links ">
        <h4>Contact Us</h4>
        <div className="footer-contact">
             
              <p><strong>Email:</strong> <br /><span>info@bojotech.com</span></p>
             <p><strong>Phone:</strong></p>
<p className="mb-1">+91 9009696937</p>
{/* <p>+1 (267) 841-8017</p> */}
        </div>
      </div>

      <div className="col-lg-2 col-md-3 footer-links">
        <h4>Useful Links</h4>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/features">Features</Link></li>
             <li><Link to="/blog">Blogs</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>

   <div className="col-lg-2 col-md-3 footer-links">
  <h4>Our Services</h4>
 <ul>
  {/* <li><a href="#features-tab-6" onClick={() => activateTab("features-tab-1")}>Custom Software Development</a></li>
  <li><a href="#features-tab-1" onClick={() => activateTab("features-tab-2")}>Cloud Solutions</a></li>
  <li><a href="#features-tab-3" onClick={() => activateTab("features-tab-4")}>Cybersecurity</a></li>
  <li><a href="#features-tab-2" onClick={() => activateTab("features-tab-3")}>Mobile App Development</a></li>
  <li><a href="#features-tab-4" onClick={() => activateTab("features-tab-5")}>IT Consulting</a></li>
  <li><a href="#features-tab-5" onClick={() => activateTab("features-tab-6")}>Staff Augmentation</a></li> */}
  <li>
  <Link to="/services?tab=1">Custom Software</Link>
</li>
<li>
  <Link to="/services?tab=2">Cloud Solutions</Link>
</li>
<li>
  <Link to="/services?tab=3">Mobile App Development</Link>
</li>
<li>
  <Link to="/services?tab=4">Cybersecurity</Link>
</li>
<li>
  <Link to="/services?tab=5">Data Analytics</Link>
</li>
<li>
  <Link to="/services?tab=6">Consultation</Link>
</li>
<li>
  <Link to="/services?tab=7">Staff Augmentation</Link>
</li>
<li>
  <Link to="/services?tab=8">AI Consulting</Link>
</li>

</ul>

</div>


    </div>
  </div>

  <div className="container copyright text-center mt-4">
    <p>© <span>Copyright</span> <strong className="px-1 sitename"><Link to="/">BojoTech</Link></strong> <span>All Rights Reserved</span></p>

  </div>
</footer>

        </div>
    );
};

export default Footer;